import type {PerkIntegrationSpec, PerkIntegrationStruct} from '@cohort/shared/apps/app';
import {LocalizedUrlSchema} from '@cohort/shared/schema/common';
import {z} from 'zod';

export const CohortLinkConfigSchema = z.object({
  url: LocalizedUrlSchema,
});
export type CohortLinkConfig = z.infer<typeof CohortLinkConfigSchema>;

export const CohortLinkStateSchema = z.object({});
export type CohortLinkState = z.infer<typeof CohortLinkStateSchema>;

export const CohortLinkUsageDataSchema = z.object({});
export type CohortLinkUsageData = z.infer<typeof CohortLinkUsageDataSchema>;

export const ExposedCohortLinkUsageDataSchema = z.object({});
export type ExposedCohortLinkUsageData = z.infer<typeof ExposedCohortLinkUsageDataSchema>;

export const CohortLinkExposedConfigSchema = CohortLinkConfigSchema;
export type CohortLinkExposedConfig = z.infer<typeof CohortLinkExposedConfigSchema>;

export type CohortLinkPerkIntegrationStruct = PerkIntegrationStruct<
  'cohort.link',
  CohortLinkConfig,
  CohortLinkExposedConfig,
  CohortLinkState,
  null,
  null,
  CohortLinkUsageData,
  ExposedCohortLinkUsageData,
  ExposedCohortLinkUsageDataForExport
>;

const ExposedCohortLinkUsageDataForExportSchema = ExposedCohortLinkUsageDataSchema;
export type ExposedCohortLinkUsageDataForExport = z.infer<
  typeof ExposedCohortLinkUsageDataForExportSchema
>;

export const CohortLinkPerkIntegrationSpec: PerkIntegrationSpec<CohortLinkPerkIntegrationStruct> = {
  id: 'cohort.link' as const,
  configSchema: CohortLinkConfigSchema,
  exposedConfigSchema: CohortLinkExposedConfigSchema,
  stateSchema: CohortLinkStateSchema,
  accessDataSchema: z.null(),
  usageInputDataSchema: z.null(),
  internalUsageDataSchema: z.object({}),
  exposedUsageDataSchema: z.object({}),
  exposedUsageDataForExportSchema: z.object({}),
  defaultMaxUsagesPerToken: null,
  requiresMerchantConnection: false,
  localizedConfig: true,
};
